(()=>{
const root=document.querySelector('[data-taste-profile-places-v132]');if(!root)return;
const $=s=>root.querySelector(s);
const mode=root.dataset.sourceMode||'auto';
let shopify=[];try{shopify=JSON.parse($('[data-tpp-shopify]')?.textContent||'[]')}catch(e){}
const seed=(window.TasteProfilePlacesSeedV132||[]).map(r=>({
  id:r.place_name,active:r.active!==false,name:r.place_name,city:r.city,area:r.area,cuisine:r.cuisine,
  postcode:r.postcode,lat:Number(r.latitude)||0,lng:Number(r.longitude)||0,price:r.price_band,
  cheapEat:!!r.cheap_eat,primaryOccasion:r.primary_occasion,occasionTags:r.occasion_tags,
  description:r.why_it_fits,url:r.booking_url,rating:Number(r.rating)||0,reviewCount:Number(r.review_count)||0,
  adv:r.adventure,heat:r.heat,intensity:r.intensity,acid:r.acid,texture:r.texture,sweet:r.sweet
}));
let places=mode==='seed'?seed:mode==='shopify'?shopify:(shopify.length?shopify:seed);
places=places.filter(p=>p&&p.active!==false&&p.name&&p.city);
const profile=window.TasteProfileResultV132||{adv:50,heat:50,intensity:50,acid:50,texture:50,sweet:50};

const city=$('[data-tpp-city]'),near=$('[data-tpp-near]'),status=$('[data-tpp-status]');
const frame=$('[data-tpp-map]'),pins=$('[data-tpp-pins]'),note=$('[data-tpp-map-note]');
const featured=$('[data-tpp-featured]'),all=$('[data-tpp-all]'),more=$('[data-tpp-more]');
const title=$('[data-tpp-title]'),count=$('[data-tpp-count]');
const filterButtons=[...root.querySelectorAll('[data-tpp-filter]')];

const CITY={
 London:[51.5074,-0.1278],Manchester:[53.4808,-2.2426],Birmingham:[52.4862,-1.8904],
 Edinburgh:[55.9533,-3.1883],Bristol:[51.4545,-2.5879],Glasgow:[55.8642,-4.2518],
 Leeds:[53.8008,-1.5491],Liverpool:[53.4084,-2.9916]
};
const UK={west:-5.65,south:50.35,east:.85,north:56.35};
const CATS=[
 ['cheap_eat','The cheap one'],['date','The date'],['pub','The pub'],['big_night','The big night'],['wildcard','The wildcard']
];
let currentCity='',currentFilter='all',currentGroup=[],currentPicks=[];
const cacheKey='taste_profile_postcodes_v132';

function esc(s){return String(s??'').replace(/[&<>"']/g,m=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#039;'}[m]))}
function clamp(n){return Math.max(0,Math.min(100,Number(n)||50))}
function tags(p){return String(p.occasionTags||p.primaryOccasion||'').toLowerCase().split(',').map(s=>s.trim())}
function has(p,k){return k==='cheap_eat'?p.cheapEat||tags(p).includes(k):tags(p).includes(k)||p.primaryOccasion===k}
function match(p){
 const W={adv:1.2,heat:1.05,intensity:1.15,acid:.9,texture:.75,sweet:.65};let s=0,w=0;
 Object.entries(W).forEach(([k,v])=>{s+=Math.abs(clamp(profile[k])-clamp(p[k]))*v;w+=v});
 return Math.max(50,Math.min(99,Math.round(100-(s/w)*.72)))
}
function conf(p){return (Number(p.rating)||0)*10+Math.log10((Number(p.reviewCount)||0)+1)*2}
function mapUrl(b){const z=[b.west,b.south,b.east,b.north].map(n=>Number(n).toFixed(5)).join('%2C');return `https://www.openstreetmap.org/export/embed.html?bbox=${z}&layer=mapnik`}
function merc(lat){const r=Math.max(-85,Math.min(85,lat))*Math.PI/180;return Math.log(Math.tan(Math.PI/4+r/2))}
function xy(lat,lng,b){return{x:(lng-b.west)/(b.east-b.west)*100,y:(merc(b.north)-merc(lat))/(merc(b.north)-merc(b.south))*100}}
function bounds(group,c){
 const g=group.filter(p=>Number(p.lat)&&Number(p.lng));
 if(!g.length){const x=CITY[c]||[54.2,-2.5];return{west:x[1]-.18,east:x[1]+.18,south:x[0]-.12,north:x[0]+.12}}
 let W=Math.min(...g.map(p=>+p.lng)),E=Math.max(...g.map(p=>+p.lng)),S=Math.min(...g.map(p=>+p.lat)),N=Math.max(...g.map(p=>+p.lat));
 const xp=Math.max((E-W)*.22,.045),yp=Math.max((N-S)*.22,.035);return{west:W-xp,east:E+xp,south:S-yp,north:N+yp}
}
function getCache(){try{return JSON.parse(localStorage.getItem(cacheKey)||'{}')}catch(e){return{}}}
function putCache(c){try{localStorage.setItem(cacheKey,JSON.stringify(c))}catch(e){}}
function pk(s){return String(s||'').toUpperCase().replace(/\s+/g,'')}
async function geocode(group){
 const c=getCache(),need=[...new Set(group.filter(p=>!(+p.lat&&+p.lng)&&p.postcode&&!c[pk(p.postcode)]).map(p=>pk(p.postcode)))];
 for(let i=0;i<need.length;i+=100){
  try{
   const r=await fetch('https://api.postcodes.io/postcodes',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({postcodes:need.slice(i,i+100)})});
   if(!r.ok)break;const d=await r.json();
   (d.result||[]).forEach(x=>{if(x.result)c[pk(x.query)]={lat:+x.result.latitude,lng:+x.result.longitude}});putCache(c)
  }catch(e){break}
 }
 group.forEach(p=>{const h=c[pk(p.postcode)];if(h&&!(+p.lat&&+p.lng)){p.lat=h.lat;p.lng=h.lng}});
}
function choosePicks(group){
 const used=new Set(),out=[];
 CATS.forEach(([key,label])=>{
  let p=group.filter(x=>has(x,key)&&!used.has(x.id)).sort((a,b)=>b.match-a.match||conf(b)-conf(a))[0];
  if(!p)p=group.filter(x=>!used.has(x.id)).sort((a,b)=>b.match-a.match||conf(b)-conf(a))[0];
  if(p){used.add(p.id);out.push({category:label,key,place:p})}
 });
 return out
}
function card(item){
 const p=item.place||item,r=p.rating?`★ ${Number(p.rating).toFixed(1)}${p.reviewCount?` · ${Number(p.reviewCount).toLocaleString('en-GB')} reviews`:''}`:'';
 const meta=[p.price,p.area,r].filter(Boolean).join(' · ');
 return `<article class="tpp-card"><div class="tpp-card__kind">${esc(item.category||p.primaryOccasion||'Match')}</div><div><div class="tpp-card__top"><h4>${p.url?`<a href="${esc(p.url)}" target="_blank" rel="noopener">${esc(p.name)}</a>`:esc(p.name)}</h4><b>${p.match}%</b></div><p>${esc(p.description||'A strong match for the way you like to eat.')}</p><small>${esc(meta)}</small></div></article>`
}
function renderCards(group){
 currentPicks=choosePicks(group);featured.innerHTML=currentPicks.map(card).join('');
 all.innerHTML=group.slice(0,15).map((p,i)=>card({category:String(i+1).padStart(2,'0'),place:p})).join('')
}
function renderOverview(){
 currentCity='';currentFilter='all';filterButtons.forEach(b=>b.classList.toggle('is-active',b.dataset.tppFilter==='all'));
 currentGroup=places.map(p=>({...p,match:match(p)})).sort((a,b)=>b.match-a.match||conf(b)-conf(a));
 title.textContent='Five places we think your palate belongs.';count.textContent='Across 8 launch cities';
 renderCards(currentGroup);frame.src=mapUrl(UK);note.textContent='UK overview · 8 launch cities';pins.innerHTML='';
 Object.entries(CITY).forEach(([name,c])=>{
  const q=xy(c[0],c[1],UK),n=places.filter(p=>p.city===name).length,b=document.createElement('button');
  b.className='tpp-pin tpp-pin--city';b.type='button';b.style.left=q.x+'%';b.style.top=q.y+'%';
  b.innerHTML=`<span>${n}</span><em>${esc(name)}</em>`;b.addEventListener('click',()=>{city.value=name;showCity(name)});pins.appendChild(b)
 });
 status.textContent='Choose a city, tap a map marker, or use your location.'
}
function filtered(g){return currentFilter==='all'?g:g.filter(p=>has(p,currentFilter))}
function drawCity(){
 const g=filtered(currentGroup),m=g.filter(p=>+p.lat&&+p.lng),b=bounds(m,currentCity);
 frame.src=mapUrl(b);note.textContent=`${currentCity} · ${g.length} matched places`;pins.innerHTML='';
 m.forEach((p,i)=>{const q=xy(+p.lat,+p.lng,b);if(q.x<0||q.x>100||q.y<0||q.y>100)return;const a=document.createElement(p.url?'a':'button');
  a.className='tpp-pin';a.style.left=q.x+'%';a.style.top=q.y+'%';if(p.url){a.href=p.url;a.target='_blank';a.rel='noopener'}else a.type='button';
  a.innerHTML=`<span>${i+1}</span><em>${esc(p.name)}</em>`;pins.appendChild(a)
 })
}
async function showCity(name){
 currentCity=name;currentFilter='all';filterButtons.forEach(b=>b.classList.toggle('is-active',b.dataset.tppFilter==='all'));
 currentGroup=places.filter(p=>p.city===name).map(p=>({...p,match:match(p)})).sort((a,b)=>b.match-a.match||conf(b)-conf(a));
 title.textContent=`Five places for your palate in ${name}.`;count.textContent=`${currentGroup.length} curated places`;
 renderCards(currentGroup);frame.src=mapUrl(bounds([],name));note.textContent=`${name} · locating restaurant pins`;status.textContent='Resolving restaurant map positions…';
 await geocode(currentGroup);drawCity();status.textContent=`${currentGroup.length} curated places in ${name}.`
}
[...new Set(places.map(p=>p.city))].sort().forEach(n=>{const o=document.createElement('option');o.value=n;o.textContent=n;city.appendChild(o)});
city.addEventListener('change',()=>city.value?showCity(city.value):renderOverview());
filterButtons.forEach(b=>b.addEventListener('click',()=>{
 currentFilter=b.dataset.tppFilter;filterButtons.forEach(x=>x.classList.toggle('is-active',x===b));
 const g=filtered(currentGroup);renderCards(g);if(currentCity)drawCity()
}));
more.addEventListener('click',()=>{const open=!all.hidden;all.hidden=open;more.querySelector('span:first-child').textContent=open?'See more matched places':'Hide extra matches'});
near.addEventListener('click',()=>{
 if(!navigator.geolocation){status.textContent='Location is not available in this browser.';return}
 status.textContent='Finding your nearest launch city…';
 navigator.geolocation.getCurrentPosition(pos=>{
  const lat=pos.coords.latitude,lng=pos.coords.longitude;
  const d=(a,b,c,d)=>{const R=6371,p=Math.PI/180,x=(c-a)*p,y=(d-b)*p,z=Math.sin(x/2)**2+Math.cos(a*p)*Math.cos(c*p)*Math.sin(y/2)**2;return 2*R*Math.asin(Math.sqrt(z))};
  const nearest=Object.keys(CITY).sort((a,b)=>d(lat,lng,...CITY[a])-d(lat,lng,...CITY[b]))[0];city.value=nearest;showCity(nearest)
 },()=>status.textContent='Location was not shared. Choose a city instead.',{enableHighAccuracy:false,timeout:8000,maximumAge:600000})
});
window.TasteProfilePlacesV132={
 getPdfData:()=>({title:currentCity?`Where we would send you in ${currentCity}`:'Where we would send you first',picks:currentPicks})
};
renderOverview();
})();